import { add as addTime, set as setTime } from 'date-fns'

export const mergeTime = (day, time) => setTime(day, {
  hours: time.getHours(),
  minutes: time.getMinutes(),
  seconds: 0,
  milliseconds: 0,
})

/*
 * The end of a single-day event, derived from its start.
 *
 * An end time at or before the start means the event runs past midnight, so it
 * lands on the following day. The API rejects an end_date that isn't strictly
 * after start_date, so this must never return the start or earlier.
 */
export const endDateFor = (start_date, endTime) => {
  const sameDay = mergeTime(start_date, endTime)

  return sameDay > start_date
    ? sameDay
    : mergeTime(addTime(start_date, { days: 1 }), endTime)
}

/*
 * The end of a multiday event: the one the user picked, as long as the start
 * hasn't moved past it. Otherwise the day after the start — the end date picker
 * disables the start day itself, so the same day is never a valid answer here.
 */
export const multidayEndDateFor = (start_date, end_date, endTime) => {
  return end_date > start_date
    ? end_date
    : mergeTime(addTime(start_date, { days: 1 }), endTime)
}
